var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7719 2.5H14.1263C14.6324 2.5 15.1144 2.71917 15.4507 3.10223L17.8857 5.87624C18.4509 6.52001 18.4845 7.47958 17.9659 8.1623L11.4045 16.7997C10.6952 17.7334 9.30481 17.7334 8.59551 16.7997L2.03412 8.1623C1.51549 7.47958 1.54912 6.52001 2.11423 5.87624L4.54931 3.10223C4.88557 2.71917 5.36754 2.5 5.87367 2.5H8.42494M11.7719 2.5L13.5439 6.98571M11.7719 2.5H8.42494M13.5439 6.98571H17.9737M13.5439 6.98571L9.99999 17.3028L6.45612 6.98571M13.5439 6.98571H6.45612M8.42494 2.5L6.45612 6.98571M2.02629 6.98571H6.45612",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavSubscriptions);
export default __webpack_public_path__ + "static/media/sidenav-subscriptions.b4f9232103c52c1f042aeccb5caca26e.svg";
export { ForwardRef as ReactComponent };